<mat-accordion class="faq-accordion">
  <mat-expansion-panel
    (opened)="toggleComponent(faqId)"
    (closed)="toggleComponent(faqId)"
    hideToggle
  >
    <mat-expansion-panel-header>
      <mat-panel-title class="fw-500"> {{ faqQuestion }} </mat-panel-title>
       @if(!faqIsExpanded){ @if(showArrow){
      <div class="arrow-svg" [innerHTML]="arrowDownSVG | safeHTML"></div>
      } @else {
      <app-add-svg></app-add-svg>

      } } @else { @if(showArrow){
      <div class="arrow-svg" [innerHTML]="arrowUpSVG | safeHTML"></div>
      } @else {
      <app-minus-svg></app-minus-svg>
      } }
    </mat-expansion-panel-header>
    <div class="faq-description">
      <span [innerHTML]="faqAnswer | safeHTML"> </span>
    </div>
  </mat-expansion-panel>
</mat-accordion>
